import React, {useState} from 'react';
import {
    deleteFlujoDocumentoEmpleadoAPI,
} from "../../../../consumers/backendApisUrls";
import GenericModal from "../../../../components/modal/GenericModal";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";

const EliminarFlujoDocumentoEmpleado = ({toggleModal, refreshPage, idFlujoDocumentoEmpleado}) => {
    const [executeManagePost] = useManagePostRequest();

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        try {
            let api = deleteFlujoDocumentoEmpleadoAPI(idFlujoDocumentoEmpleado);
            let payload = {};
            await executeManagePost(api, payload, callback);
        } catch (error) {
            console.error(error);
        }
    }

    const callback = () => {
        toggleModal();
        refreshPage();
    }

  return (
      <GenericModal showModal={toggleModal} width={"420px"} titulo={"Eliminar"}>
          <div className="modal-body pt-0 pl-0">
              <div className="container-fluid">
                  <p className="mb-0">
                      ¿Desea eliminar este registro?
                  </p>
                  <p className="mb-0">
                      Esta acción no se podrá deshacer.
                  </p>
              </div>
          </div>
          <div className="modal-footer d-flex justify-content-end" >
              <div className="button">
                  <button
                      className="btn btn-primary generic-button-ficha-modal mr-2"
                      onClick={() => { toggleModal() }}>
                      Cancelar
                  </button>
                  <button
                      style={{backgroundColor: "#E76F51"}}
                      type="button"
                      className="btn btn-primary generic-button-ficha-modal generic-button-hover-rojo"
                      onClick={() => { handleSubmit() }}>
                      Eliminar
                  </button>
              </div>
          </div>
      </GenericModal>
  )
}

export default EliminarFlujoDocumentoEmpleado